import { render, staticRenderFns } from "./CaseStudyContent.vue?vue&type=template&id=37253061&scoped=true&"
import script from "./CaseStudyContent.vue?vue&type=script&lang=js&"
export * from "./CaseStudyContent.vue?vue&type=script&lang=js&"
import style0 from "./CaseStudyContent.vue?vue&type=style&index=0&id=37253061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37253061",
  null
  
)

export default component.exports